export default function isFunction(test) {
  return typeof test === 'function';
}
